import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../api/auth.js';
import { ApiError } from '../api/client.js';
import { useSession } from '../state/session.js';
import { useToast } from '../components/Toast.js';

export function LoginPage() {
  const navigate = useNavigate();
  const setSession = useSession((s) => s.setSession);
  const toast = useToast();
  const [email, setEmail] = useState('ayesha@raahi.test');
  const [password, setPassword] = useState('raahi1234');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const bundle = await login({ email, password });
      if (bundle.user.role !== 'rider') {
        setError('This account is for staff. Please use a rider account.');
        return;
      }
      setSession(bundle);
      toast.show(`Welcome back, ${bundle.user.name.split(' ')[0]}.`, 'success');
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Could not sign you in. Please try again.';
      setError(msg);
      toast.show(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-svh max-w-mobile flex-col justify-center px-6 py-10">
      <div className="mb-8">
        <p className="font-display text-3xl font-bold tracking-tight">Raahi</p>
        <p className="mt-1 text-sm text-muted">Sign in to book a ride.</p>
      </div>
      <form onSubmit={onSubmit} className="space-y-3">
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Email</span>
          <input
            type="email"
            className="input"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block font-medium">Password</span>
          <input
            type="password"
            className="input"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error ? (
          <p role="alert" className="text-sm text-red-600">
            {error}
          </p>
        ) : null}
        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted">
        New to Raahi?{' '}
        <Link to="/register" className="font-semibold text-ink">
          Create an account
        </Link>
      </p>
    </div>
  );
}
